/**
 * Converts an object to a string representation with customizable formatting.
 *
 * @param obj - The object to convert to a string.
 * @param format - A function to customize the key-value format.
 *                 Defaults to 'key=value'.
 * @param separator - The separator between key-value pairs. Defaults to a comma (`,`).
 * @returns The string representation of the object.
 */
export function objectToString<T>(
  obj: Record<string, T>,
  format: (key: string, value: T) => string = (key, value) => `${key}=${value}`,
  separator = ',',
): string {
  return Object.entries(obj)
    .map(([key, value]) => format(key, value))
    .join(separator);
}
